import React from 'react';

/**
 * Renders a heart SVG filled with the provided color.
 * size in pixels controls both width and height keeping aspect ratio.
 */
const HeartColored = ({ color = '#ffffff', size = 48 }) => {
  return (
    <svg
      width={size}
      height={size * (997 / 1088)}
      viewBox="0 0 1088 997"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <path
        d="M544.366 972.71C548.166 969.41 551.166 967.01 554.066 964.41C637.866 889.71 721.466 814.71 805.566 740.31C856.866 694.91 909.966 651.61 955.566 600.31C1041.57 503.51 1079.87 390.71 1066.07 261.51C1061.17 215.11 1048.17 170.31 1020.57 131.81C971.366 63.3103 904.266 25.1103 819.666 19.9103C723.066 14.0103 643.066 47.7103 581.066 122.41C569.866 135.91 559.966 150.31 549.466 164.21C547.866 166.31 546.166 168.31 544.066 170.81C541.066 166.21 538.666 162.71 536.266 159.21C466.566 55.6103 371.066 4.01037 245.466 22.8103C146.366 37.7103 74.7656 92.8103 40.4656 188.71C3.66561 291.71 16.6656 392.91 60.5656 491.21C88.5656 553.91 132.566 604.81 182.866 650.31C259.466 719.71 337.166 787.81 414.366 856.61C457.466 895.01 500.466 933.51 544.366 972.71Z"
        fill={color}
        stroke="white"
        strokeWidth="36.4"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default HeartColored;
